import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "live-abnormal" }
const _hoisted_2 = { class: "live-abnormal-text" }

import {withDefaults} from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    text: { default: '' },
    icon: { default: 'end' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['icon', `icon-${__props.icon}`])
    }, null, 2 /* CLASS */),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "text", {}, () => [
        _createTextVNode(_toDisplayString(__props.text), 1 /* TEXT */)
      ])
    ])
  ]))
}
}

})